import React from 'react'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import { find } from 'lodash'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { Button, Input, Form } from 'components/Forms'
import { Alert } from 'ui'
import { getUserName } from 'services/Utilities'
import { Card } from 'ui'

const ContactUserPriorityModal = ({ id, contactUsers, closeModal }) => {
  const { priority, userId } = find(contactUsers, { _id: id })

  const changePriority = async (values, actions) => {
    const { success } = await Api.put(`contact/users/changePriority`, { _id: id, priority: values.priority })
    if (!success) {
      actions.setStatus({ type: 'danger', msg: 'manager.contactLists.CONTACT_USER_PRIORITY_MODAL.ERROR_SAVING_PRIORITY' })
      actions.setSubmitting(false)
    } else closeModal()
  }

  return (
    <BaseModal hideButtons title={`manager.contactLists.CONTACT_USER_PRIORITY_MODAL`} titleVar={{ name: getUserName(userId) }}>
      <Formik enableReinitialize={true} initialValues={{ priority }} onSubmit={changePriority}>
        {({ isSubmitting, status, setStatus }) => {
          return (
            <Form className="mt-2">
              {/* Error message */}
              <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                {status?.msg}
              </Alert>
              <Card className="bg-light mt-2">
                <Card.Body>
                  <Input type="number" module="manager.contactLists.CONTACT_USER_PRIORITY_MODAL" name="priority" required min="1" step="1" />
                </Card.Body>
              </Card>
              <div className="mt-2">
                <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} text="SUBMIT" />
                <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => closeModal()} />
              </div>
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

const mapStateToProps = ({ contactLists }) => ({ contactUsers: contactLists.currentContactUsers })
const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(ContactUserPriorityModal)
